import  {get,cloneDeep} from "lodash-es";
import {
  mutiQueryArticleInCache,
  getActiveListFormPlatform,
  getArticleDetail,
} from "@/api";
import { getSassmallArticleByUrl } from "~/sassmall/api/content";
export function filterArclistData(pages) {
  let nowConfigs = pages[0].elements;
  let configList = filterTreeConf(nowConfigs);
  let requestMap = {};
  configList.map((item) => {
    requestMap[item.lvKey] = {
      id: item.conf.value,
      topicId: item.conf.themeId,
      categoryId: item.conf.categoryId,
      tagsValue: item.conf.tagValue,
      pageNo: 0,
      getDetail: item.conf.showStyle == "contentList1",
      pageSize: item.conf.isShowArticleLength || 10,
    };
  });

  return requestMap;
}
export function filterArclistDetailDataConfigs(pages) {
  let nowConfigs = pages[0].elements;
  let configList = filterTreeConf(nowConfigs,[],["articleDetailItem"]);
  
  

  return configList;
}
export function makeAllArcListMap($fetch,headers,res, allArcListMap,pages) {
  return new Promise(async (resolve, reject) => {
    if (res && res.dataList && res.dataList[0]) {
      const findData = res.dataList && res.dataList[0];
      
      if (findData.areaData) {
        let areaData = [];
        try {
          areaData = JSON.parse(findData.areaData);
        } catch (e) {
          console.log(e);
        }
        pages = areaData;
        if (pages) {
          let newMergePages = mergeCommonComponentsItemData(pages);
          //  console.log("requestTemplateMap",requestTemplateMap)
          let requestMap = filterArclistData(newMergePages);

          let requestList = [];
          let requestParamsList = [];
          Object.keys(requestMap).map((key) => {
            requestList.push(key);
            requestParamsList.push(requestMap[key]);
          });

          let resAllArcListData =null;
          if(requestParamsList.length){
            resAllArcListData = await mutiQueryArticleInCache($fetch,headers,{
              param: requestParamsList,
            });
          }
          if (resAllArcListData && resAllArcListData.data) {
            resAllArcListData.data.map((o, i) => {
              allArcListMap[requestList[i]] =
                o && o.dataList ? o : { dataList: [], totalRecord: 0 };
            });
          }
          resolve({allArcListMap,pages})
        }
      }
    }else{
      resolve({allArcListMap,pages})
    }
  });
}

export function getDetailPageData($fetch,headers,pages,route) {
  return new Promise(async (resolve, reject) => {
        let detailData=null
        
        if (pages) {
          // 获取详情内容
 
          let  configs = filterArclistDetailDataConfigs(pages);
        
          let config=configs&&configs[0]?configs[0].conf:null
          if(!config){
            resolve(detailData)
            return ;
          }
          let detailId = config.isGetRouteId
          ? (route.query && (route.query.detailId || route.query.url)) || ""
          : config.value;
          if (!detailId && (config.categoryId || config.themeId)) {
            const listResponse = await getActiveListFormPlatform({
              categoryId: config.categoryId,
              topicId: config.themeId,
              pageNo: 0,
              pageSize: 1,
            }, $fetch, headers);
            detailId = listResponse?.data?.dataList?.[0]?.id || "";
          }
          if (!detailId) {
            resolve(detailData)
            return;
          }

          let resAll = route.query?.url
            ? await getSassmallArticleByUrl(route.query.url)
            : await getArticleDetail({ id: detailId }, $fetch, headers);
          
          const res = resAll && resAll.data;
          const article = res?.data || res;
          if (article && typeof article === "object" && !Array.isArray(article)) {
            detailData = article;
          }
          resolve(detailData)
        }else{
          resolve(detailData)
        }
     
   
  });
}

export function mergeCommonComponentsItemData(pages) {
  let newPages =  cloneDeep(pages);
  let nowConfigs = newPages[0].elements;
  let configList = filterTreeConf(nowConfigs, [], ["commonComponentsItem"]); // 获取得到模板的配置

  configList.map((o) => {
    let templateKeys = o.lvKey;

    let parentKeys = templateKeys.slice(0, -1);
    let findParentConfig = null;

    while (parentKeys.length > 0) {
      let findIdx = parentKeys.shift();
      if (!findParentConfig) {
        findParentConfig = nowConfigs[findIdx];
      } else if (
        findParentConfig &&
       get(findParentConfig, `config.items[${findIdx}]`)
      ) {
        findParentConfig = get(
          findParentConfig,
          `config.items[${findIdx}]`
        );
      } else if (
        findParentConfig &&
        get(findParentConfig, `config.children[${findIdx}]`)
      ) {
        findParentConfig = get(
          findParentConfig,
          `config.children[${findIdx}]`
        );
      } else if (parentKeys.length == 0) {
        findParentConfig = null;
      }
    }
    let findParentChildrens =
      get(findParentConfig, `config.items`) ||
      get(findParentConfig, `config.children`) ||
      [];

    let templateIdx = templateKeys[templateKeys.length - 1];
    let configDataStr = get(
      findParentChildrens,
      `[${templateIdx}].config.configData`
    );
    if (configDataStr) {
      let configData = [];
      try {
        configData = JSON.parse(configDataStr);
      } catch (e) {}
      newPages[0].info.cssText += get(
        configData,
        "[0].info.cssText",
        ""
      );
      newPages[0].info.javascriptText += get(
        configData,
        "[0].info.javascriptText",
        ""
      );
      //合并js和css
      findParentChildrens[templateIdx] = {
        type: "row",
        config: {
          ...findParentChildrens[templateIdx].config,
          configData: null,
          children: [
            {
              type: "col",
              config: {
                span: 0,
                isFlex: false,
                showTime: [],
                backgroundColor: null,
                backgroundImage: "",
                padding: { left: 0, top: 0, right: 0, bottom: 0 },
                margin: { left: 0, top: 0, right: 0, bottom: 0 },
                radius: {
                  leftTop: 0,
                  rightTop: 0,
                  leftBottom: 0,
                  rightBottom: 0,
                },
                classStyle: "",
                id: "",
                styles: "",
                height: null,
                width: null,
                shadow: false,

                items: get(configData, "[0].elements", []),
              },
            },
          ],
        },
      };
    }
  });
  return newPages;
}
export function filterCommonComponentsItemData(pages) {
  let nowConfigs = pages[0].elements;
  let configList = filterTreeConf(nowConfigs, [], ["commonComponentsItem"]);
  let requestMap = {};
  configList.map((item) => {
    requestMap[item.lvKey] = {
      id: item.conf.id,
      configData: item.conf.configData,
    };
  });

  return requestMap;
}

export function filterTreeConf(
  list,
  lvKey = [],
  findTypes = ["articleListItem", "topicArticleListItem"]
) {
  let res = [];
  list.map((o, i) => {
    if (o.type == "row") {
      res = [
        ...res,
        ...filterTreeConf(o.config.children, [...lvKey, i], findTypes),
      ];
    } else if (o.type == "col") {
      res = [
        ...res,
        ...filterTreeConf(o.config.items, [...lvKey, i], findTypes),
      ];
    } else if (o.type == "tabsItem") {
      res = [
        ...res,
        ...filterTreeConf(o.config.items, [...lvKey, i], findTypes),
      ];
    } else if (findTypes.indexOf(o.type) >= 0) {
      res.push({
        conf: o.config,
        lvKey: [...lvKey, i],
      });
    }
  });
  return res;
}
